webpackJsonp([0],{

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(389),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-271ce24c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(395),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7fa9ef52",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(381)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(388),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(393),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61c0d909",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(397),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(391),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3485322d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(394),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70305a28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(392),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(398),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e804391e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pathToBreadcrumbs; });
function pathToBreadcrumbs(root, path) {
    var p = path || '';
    var elements = p.split('/').filter(function (element) {
        return element.length > 0;
    });

    return [root].concat(elements.map(function (element, index) {
        return {
            id: element,
            text: element,
            to: root.to + '/' + elements.slice(0, index + 1).join('/')
        };
    }));
}



/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'callback',
    data: function data() {
        return {
            title: 'Login callback'
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch('auth/LOGIN').then(function () {
            _this.$router.replace('/');
        }, function () {
            _this.$router.replace('/error');
        });
    }
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Consent',
    props: {
        issuer: { type: String, required: true },
        intent: { type: String, required: true },
        user: { type: String, required: true }
    },
    data: function data() {
        return {};
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('consents', {
        consent: function consent(state) {
            return state.consent;
        }
    })),
    methods: {
        userReadable: function userReadable(date) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('LLL');
        }
    },
    created: function created() {
        var issuer = this.issuer;
        var intent = this.intent;
        var user = this.user;

        this.$store.commit('nav/BREADCRUMBS', [{ id: 'consents', text: 'Consents', to: '/consents' }, { id: 'details', text: 'Details', to: '/consents/' + issuer + '/' + intent + '/' + user }]);

        this.$store.dispatch('consents/LOAD_CONSENT', { issuer: issuer, intent: intent, user: user });
    }
});

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Consents',
    data: function data() {
        return {
            tabs: ['all', 'granted', 'revoked'],
            active_tab: 'all'
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])('consents', {
        consents: function consents(state) {
            return state.consents;
        }
    }), {
        filter: {
            get: function get() {
                return this.$store.state.consents.filter;
            },
            set: function set(filter) {
                this.$store.dispatch('consents/LIST_FILTER', filter);
            }
        }
    }),
    methods: {
        key: function key(consent) {
            return consent.IntentIssuerCode + '_' + consent.IntentCode + '_' + consent.DataOwnerCode;
        },
        userReadable: function userReadable(date) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('LLL');
        },
        details: function details(item) {
            this.$router.push({ path: '/consents/' + item.IntentIssuerCode + '/' + item.IntentCode + '/' + item.DataOwnerCode });
        }
    },
    created: function created() {
        this.$store.commit('nav/BREADCRUMBS', [{ id: 'consents', text: 'Consents', to: '/consents' }]);

        this.$store.dispatch('consents/LIST_ALL');
    }
});

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);

//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Intent',
    props: {
        issuer: { type: String, required: true },
        intent: { type: String, required: true }
    },
    data: function data() {
        return {};
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('intents', {
        consents: function consents(state) {
            return state.consents;
        }
    })),
    methods: {
        filterChanged: function filterChanged(filter) {
            var issuer = this.issuer;
            var intent = this.intent;

            this.$store.dispatch('intents/LIST_INTENT_CONSENTS', { issuer: issuer, intent: intent, filter: filter });
        }
    },
    created: function created() {
        var issuer = this.issuer;
        var intent = this.intent;
        var filter = 'all';

        this.$store.commit('nav/BREADCRUMBS', [{ id: 'intents', text: 'Intents', to: '/intents' }, { id: 'consents', text: 'Consents', to: '/intents/' + issuer + '/' + intent }]);

        this.$store.dispatch('intents/LIST_INTENT_CONSENTS', { issuer: issuer, intent: intent, filter: filter });
    }
});

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Intents',
    data: function data() {
        return {
            title: 'Intents'
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('intents', {
        intents: function intents(state) {
            return state.allIntents;
        }
    })),
    methods: {
        itemUrl: function itemUrl(item) {
            var issuer = item.Issuer;
            var intent = item.Code;
            return 'https://me.nowyu.com/requests/' + issuer + '/' + intent + '?autologin=true';
        },
        add: function add() {
            this.$router.push({ path: '/intents/new' });
        },
        details: function details(item) {
            this.$router.push({ path: '/intents/' + item.Issuer + '/' + item.Code });
        }
    },
    created: function created() {
        this.$store.commit('nav/BREADCRUMBS', [{ id: 'intents', text: 'Intents', to: '/intents' }]);

        this.$store.dispatch('intents/LIST_ALL');
    }
});

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'intentsNew',
    data: function data() {
        return {
            title: 'New Intent',
            valid: false,
            searchScopes: undefined
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('intents', {
        intent: function intent(state) {
            return state.intent;
        },
        loadedScopes: function loadedScopes(state) {
            return state.scopes.found;
        },
        loadingScopes: function loadingScopes(state) {
            return state.scopes.loading;
        }
    })),
    watch: {
        searchScopes: function searchScopes(value) {
            if (value) {
                this.queryScopes(value);
            }
        }
    },
    methods: {
        add: function add() {
            if (this.$refs.newIntent.validate()) {
                this.$store.dispatch('intents/SAVE');
            }
        },
        clear: function clear() {
            this.$refs.newIntent.reset();
        },
        updateCode: function updateCode(value) {
            this.$store.commit('intents/UPDATE_CODE', value);
        },
        updateShortDescription: function updateShortDescription(value) {
            this.$store.commit('intents/UPDATE_SHORT_DESCRIPTION', value);
        },
        updateDescription: function updateDescription(value) {
            this.$store.commit('intents/UPDATE_DESCRIPTION', value);
        },
        updateScopes: function updateScopes(value) {
            this.$store.commit('intents/UPDATE_SCOPES', value);
        },
        queryScopes: function queryScopes(value) {
            this.$store.dispatch('intents/QUERY_SCOPES', value);
        }
    },
    created: function created() {
        this.$store.commit('nav/BREADCRUMBS', [{ id: 'intents', text: 'Intents', to: '/intents' }, { id: 'intents-new', text: 'new', to: '/intents/new' }]);
        this.$store.dispatch('intents/NEW');
    }
});

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    data: function data() {
        return {
            title: 'Login'
        };
    },
    created: function created() {
        this.$store.commit('auth/AUTHORIZE');
    }
});

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'NotFound',
    data: function data() {
        return {
            title: 'Not Found',
            error: 404,
            msg: 'Not Found'
        };
    },
    created: function created() {
        this.$store.commit('nav/BREADCRUMBS', []);
    }
});

/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_breadcrumbs__ = __webpack_require__(362);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'provider',
    props: {
        profilePath: String
    },
    data: function data() {
        return {
            title: 'Profile Provider Schemas'
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('profileProviders', {
        provider: function provider(state) {
            return state.provider;
        },
        schemas: function schemas(state) {
            return state.schemas;
        },
        endpoints: function endpoints(state) {
            return state.endpoints;
        },
        mappings: function mappings(state) {
            return state.mappings;
        },
        params: function params(state) {
            return state.params;
        }
    })),
    methods: {
        showDetails: function showDetails() {
            return this.params.schema === undefined;
        },
        showEndpoints: function showEndpoints() {
            return this.params.schema !== undefined && this.params.endpoint === undefined;
        },
        showMappings: function showMappings() {
            return this.params.schema !== undefined && this.params.endpoint !== undefined;
        },
        schema: function schema(code) {
            if (this.params.schema !== code) {
                this.$router.push({ path: '/providers/' + this.params.profileProvider + '/' + code });
            }
        },
        endpoint: function endpoint(code) {
            if (this.params.endpoint !== code) {
                this.$router.push({ path: '/providers/' + this.params.profileProvider + '/' + this.params.schema + '/' + code });
            }
        },
        mapping: function mapping(code) {
            if (this.params.mapping !== code) {
                var provider = this.params.profileProvider;
                var schema = this.params.schema;
                var mapping = this.params.mapping;
                this.$router.push({ path: '/providers/' + provider + '/' + schema + '/' + mapping + '/' + code });
            }
        },
        profilePathChanged: function profilePathChanged(newPath) {
            var breadcrumbs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_breadcrumbs__["a" /* pathToBreadcrumbs */])({
                id: 'profileProviders',
                text: 'Profile Providers',
                to: '/providers'
            }, newPath);
            var profileProvider = breadcrumbs[1].id;
            var schema = breadcrumbs[2] ? breadcrumbs[2].id : undefined;
            var endpoint = breadcrumbs[3] ? breadcrumbs[3].id : undefined;
            var mapping = breadcrumbs[4] ? breadcrumbs[4].id : undefined;

            this.$store.commit('nav/BREADCRUMBS', breadcrumbs);
            this.$store.dispatch('profileProviders/LOAD', {
                profileProvider: profileProvider,
                schema: schema,
                endpoint: endpoint,
                mapping: mapping
            });
        },
        hasDoc: function hasDoc(item) {
            return item.DocUrl && item.DocUrl.length > 0;
        }
    },
    watch: {
        profilePath: function profilePath(newPath) {
            this.profilePathChanged(newPath);
        }
    },
    created: function created() {
        this.profilePathChanged(this.profilePath);
    }
});

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProfileProviderCard__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProfileProviderCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ProfileProviderCard__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        ProfileProviderCard: __WEBPACK_IMPORTED_MODULE_2__components_ProfileProviderCard___default.a
    },
    name: 'providers',
    data: function data() {
        return {
            title: 'Profile Providers'
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('profileProviders', {
        providers: function providers(state) {
            return state.providers;
        }
    })),
    methods: {
        detail: function detail(code) {
            this.$router.push({ path: '/providers/' + code });
        }
    },
    created: function created() {
        this.$store.commit('nav/BREADCRUMBS', [{ id: 'providers', text: 'Profile Providers', to: '/providers' }]);

        this.$store.dispatch('profileProviders/LIST_ALL');
    }
});

/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_breadcrumbs__ = __webpack_require__(362);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    name: 'PropertiesList',
    props: {
        propspath: String
    },
    data: function data() {
        return {
            title: 'Properties'
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('properties', {
        properties: function properties(state) {
            return state.properties;
        }
    })),
    methods: {
        details: function details(code) {
            // we only go 1 level deep
            if (!this.propspath) {
                var path = this.$route.path;
                this.$router.push({ path: path + '/' + code });
            }
        },
        props: function props(newPath) {
            var breadcrumbs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_breadcrumbs__["a" /* pathToBreadcrumbs */])({
                id: 'properties',
                text: 'Properties',
                to: '/properties'
            }, newPath);
            var lastId = breadcrumbs.length > 1 ? breadcrumbs[breadcrumbs.length - 1].id : undefined;

            this.$store.commit('nav/BREADCRUMBS', breadcrumbs);
            this.$store.dispatch('properties/LIST_ALL', lastId);
        }
    },
    watch: {
        propspath: function propspath(newPath) {
            this.props(newPath);
        }
    },
    created: function created() {
        this.props(this.propspath);
    }
});

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Intent.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".v-container[data-v-271ce24c]{min-height:0}.flex .label[data-v-271ce24c]:after{content:\":\"}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-we/src/pages/Consent.vue"],"names":[],"mappings":"AACA,8BACE,YAAc,CACf,AACD,oCACE,WAAa,CACd","file":"Consent.vue","sourcesContent":["\n.v-container[data-v-271ce24c] {\n  min-height: 0;\n}\n.flex .label[data-v-271ce24c]:after {\n  content: \":\";\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".error-details[data-v-3485322d]{top:0;bottom:0;left:0;right:0;position:absolute;text-align:center;padding-top:20%}.desc[data-v-3485322d],h1[data-v-3485322d]{display:inline-block;vertical-align:middle}h1[data-v-3485322d]{border-right:1px solid rgba(0,0,0,.3);font-weight:500}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-we/src/pages/NotFound.vue"],"names":[],"mappings":"AACA,gCACI,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,kBAAmB,AACnB,kBAAmB,AACnB,eAAiB,CACpB,AACD,2CACI,qBAAsB,AACtB,qBAAuB,CAC1B,AACD,oBACI,sCAA0C,AAC1C,eAAiB,CACpB","file":"NotFound.vue","sourcesContent":["\n.error-details[data-v-3485322d] {\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    position: absolute;\n    text-align: center;\n    padding-top: 20%;\n}\nh1[data-v-3485322d], .desc[data-v-3485322d] {\n    display: inline-block;\n    vertical-align: middle;\n}\nh1[data-v-3485322d] {\n    border-right: 1px solid rgba(0, 0, 0, .3);\n    font-weight: 500;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".list--group .list__tile[data-v-61c0d909]{padding-left:32px}a.nostyle[data-v-61c0d909]:link,a.nostyle[data-v-61c0d909]:visited{text-decoration:inherit;color:inherit;cursor:auto}a[target=_blank][data-v-61c0d909]:after{font-family:FontAwesome;content:\" \\F08E\"}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-we/src/pages/Intents.vue"],"names":[],"mappings":"AACA,0CACE,iBAAmB,CACpB,AAMD,mEACE,wBAAyB,AACzB,cAAe,AACf,WAAa,CACd,AACD,wCACE,wBAAyB,AACzB,gBAAkB,CACnB","file":"Intents.vue","sourcesContent":["\n.list--group .list__tile[data-v-61c0d909] {\n  padding-left: 32px;\n}\na.nostyle[data-v-61c0d909]:link {\n  text-decoration: inherit;\n  color: inherit;\n  cursor: auto;\n}\na.nostyle[data-v-61c0d909]:visited {\n  text-decoration: inherit;\n  color: inherit;\n  cursor: auto;\n}\na[target=\"_blank\"][data-v-61c0d909]:after {\n  font-family: FontAwesome;\n  content: ' \\f08e';\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".v-container[data-v-70305a28]{min-height:0}.flex .label[data-v-70305a28]:after{content:\":\"}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-we/src/pages/ProfileProvider.vue"],"names":[],"mappings":"AACA,8BACE,YAAc,CACf,AACD,oCACE,WAAa,CACd","file":"ProfileProvider.vue","sourcesContent":["\n.v-container[data-v-70305a28] {\n  min-height: 0;\n}\n.flex .label[data-v-70305a28]:after {\n  content: \":\";\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".list__tile .bold[data-v-7fa9ef52]{font-weight:700}.list__tile .visible-hover[data-v-7fa9ef52]{visibility:hidden}.list :hover .visible-hover[data-v-7fa9ef52]{visibility:visible}.granted[data-v-7fa9ef52]{color:#4caf50}.expired[data-v-7fa9ef52]{color:#ffc107}.revoked[data-v-7fa9ef52]{color:#ff5252}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-we/src/pages/Consents.vue"],"names":[],"mappings":"AACA,mCACE,eAAkB,CACnB,AACD,4CACE,iBAAmB,CACpB,AACD,6CACE,kBAAoB,CACrB,AACD,0BACE,aAAe,CAChB,AACD,0BACE,aAAe,CAChB,AACD,0BACE,aAAe,CAChB","file":"Consents.vue","sourcesContent":["\n.list__tile .bold[data-v-7fa9ef52] {\n  font-weight: bold;\n}\n.list__tile .visible-hover[data-v-7fa9ef52] {\n  visibility: hidden;\n}\n.list :hover .visible-hover[data-v-7fa9ef52] {\n  visibility: visible;\n}\n.granted[data-v-7fa9ef52] {\n  color: #4caf50;\n}\n.expired[data-v-7fa9ef52] {\n  color: #ffc107;\n}\n.revoked[data-v-7fa9ef52] {\n  color: #ff5252;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(349)(true);
// imports


// module
exports.push([module.i, ".v-container[data-v-e804391e]{min-height:0}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-we/src/pages/Properties.vue"],"names":[],"mappings":"AACA,8BACI,YAAc,CACjB","file":"Properties.vue","sourcesContent":["\n.v-container[data-v-e804391e] {\n    min-height: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(374);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("d3357f42", content, true);

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(375);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("0fbc3d2f", content, true);

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(376);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("926144a4", content, true);

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(377);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("3244f15f", content, true);

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(378);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("5ba9fa5a", content, true);

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(379);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("1f5bc8f8", content, true);

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(380);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(350)("38e3aca8", content, true);

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('filtered-consents-list', {
    attrs: {
      "consents": _vm.consents
    },
    on: {
      "filter": _vm.filterChanged
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.consent && _vm.consent.Intent) ? _c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    staticClass: "headline mb-1"
  }, [_vm._v(_vm._s(_vm.consent.DataOwnerCode))]), _vm._v(" "), _c('div', {
    staticClass: "title mb-3"
  }, [_vm._v(_vm._s(_vm.consent.Intent.ShortDescription))]), _vm._v(" "), _c('div', {
    staticClass: "subheading mb-3"
  }, [_vm._v(_vm._s(_vm.consent.Intent.Description))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label body-2 grey--text text--darken-1",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v("Expires by")]), _vm._v(" "), _c('v-flex', {
    staticClass: "body-2",
    attrs: {
      "xs11": ""
    }
  }, [_vm._v(_vm._s(_vm.userReadable(_vm.consent.Expiration)))])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label caption grey--text text--darken-1",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v("Issuer")]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "xs11": ""
    }
  }, [_vm._v(_vm._s(_vm.consent.IntentIssuerCode))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label caption grey--text text--darken-1",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v("Intent")]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "xs11": ""
    }
  }, [_vm._v(_vm._s(_vm.consent.IntentCode))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label caption grey--text text--darken-1",
    attrs: {
      "xs1": ""
    }
  }, [_vm._v("Owner")]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "xs11": ""
    }
  }, [_vm._v(_vm._s(_vm.consent.DataOwnerCode))])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    ref: "newIntent",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "column": "",
      "primary-title": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Issuer",
      "hint": "pulled from your profile",
      "disabled": true,
      "required": true,
      "value": _vm.intent.Issuer
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "code",
    attrs: {
      "label": "Code will be generated...",
      "hint": "Code will be generated...",
      "disabled": true,
      "required": true,
      "value": _vm.intent.Code
    },
    on: {
      "input": _vm.updateCode
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    ref: "shortDescription",
    attrs: {
      "label": "Short description",
      "hint": "What will the data be used for?",
      "value": _vm.intent.ShortDescription
    },
    on: {
      "input": _vm.updateShortDescription
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "description",
    attrs: {
      "multi-line": "",
      "label": "Description",
      "hint": "What will the data be used for?",
      "value": _vm.intent.Description
    },
    on: {
      "input": _vm.updateDescription
    }
  }), _vm._v(" "), _c('v-select', {
    ref: "scopes",
    attrs: {
      "label": "Scopes",
      "hint": "What data will be retrieved?",
      "multiple": "",
      "chips": "",
      "autocomplete": "",
      "cache-items": "",
      "async-loading": _vm.loadingScopes,
      "value": _vm.intent.Scopes,
      "items": _vm.loadedScopes,
      "search-input": _vm.searchScopes
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchScopes = $event
      },
      "input": _vm.updateScopes
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('v-btn', {
    class: {
      disabled: !_vm.valid
    },
    attrs: {
      "flat": "",
      "primary": ""
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Add intent")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-details ma-0"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h1', {
    staticClass: "display-1 pr-3 mr-3"
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h2', {
    staticClass: "body-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('span', [_vm._v(".")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.providers), function(item, index) {
    return _c('v-flex', {
      key: item.Code,
      attrs: {
        "xs12": "",
        "md2": ""
      }
    }, [_c('profile-provider-card', {
      attrs: {
        "provider": item
      },
      on: {
        "select": function($event) {
          _vm.detail(item.Code)
        }
      }
    })], 1)
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [(_vm.intents.length === 0) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-2 grey--text text--darken-1"
  }, [_vm._v("No results")]) : [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.intents), function(item, index) {
    return _c('v-list-group', {
      key: item.Code
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {}
      },
      slot: "item"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.ShortDescription))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.Scopes))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
      key: item.Description,
      on: {
        "click": function($event) {
          _vm.details(item, index)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "grey--text text--darken-4"
    }, [_vm._v(_vm._s(item.Description))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_c('a', {
      staticClass: "nostyle",
      attrs: {
        "target": "_blank",
        "href": _vm.itemUrl(item)
      }
    }, [_vm._v("\n                                            " + _vm._s(item.Code) + "\n                                        ")])])], 1)], 1)], 1)
  }))], 1)], 1)], 1)], _vm._v(" "), _c('v-btn', {
    attrs: {
      "absolute": "",
      "dark": "",
      "fab": "",
      "bottom": "",
      "right": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.showDetails()) ? [_c('div', {
    staticClass: "subheading grey--text text--darken-1 pl-4 pb-2"
  }, [_vm._v("Details")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-card-media', {
    attrs: {
      "height": "125px",
      "contain": "",
      "src": _vm.provider.Logo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.provider.Name))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("Link type")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v(_vm._s(_vm.provider.LinkType))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("Authorize url")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v(_vm._s(_vm.provider.AuthorizeUrl))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("Client ID")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v(_vm._s(_vm.provider.ClientId))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("Token url")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v(_vm._s(_vm.provider.TokenUrl))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("Profile format")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v(_vm._s(_vm.provider.ProfileFormat))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("scopes")]), _vm._v(" "), (_vm.provider.Scopes) ? _c('div', _vm._l((_vm.provider.Scopes.split(' ')), function(scope) {
    return _c('v-chip', {
      key: scope
    }, [_vm._v("\n                                            " + _vm._s(scope) + "\n                                        ")])
  })) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text text--darken-1 pl-4 pt-4 pb-2"
  }, [_vm._v("Schemas")]), _vm._v(" "), (_vm.schemas.length === 0) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-2 grey--text text--darken-1"
  }, [_vm._v("\n            No schemas\n        ")]) : [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "one-line": ""
    }
  }, _vm._l((_vm.schemas), function(item, index) {
    return _c('v-list-group', {
      key: item.Version,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.schema(item.Version)
        }
      },
      slot: "item"
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.Version))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_c('v-btn', {
      staticClass: "grey--text text--lighten-2",
      attrs: {
        "icon": "",
        "ripple": "",
        "href": item.DocUrl,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("fa-book")])], 1)], 1)], 1)], 1)], 1)
  }))], 1)], 1)], 1)]] : _vm._e(), _vm._v(" "), (_vm.showEndpoints()) ? [_c('div', {
    staticClass: "subheading grey--text text--darken-1 pl-4 pb-2"
  }, [_vm._v("Endpoints")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.endpoints), function(item, index) {
    return _c('v-list-group', {
      key: item.Code,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.endpoint(item.Code)
        }
      },
      slot: "item"
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.Code))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.ShortDescription))])], 1), _vm._v(" "), (_vm.hasDoc(item)) ? _c('v-list-tile-action', [_c('v-list-tile-action-text', [_c('v-btn', {
      staticClass: "grey--text text--lighten-2",
      attrs: {
        "icon": "",
        "ripple": "",
        "href": item.DocUrl,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("fa-book")])], 1)], 1)], 1) : _vm._e()], 1)], 1)
  }))], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.showMappings()) ? [_c('div', {
    staticClass: "subheading grey--text text--darken-1 pl-4 pb-2"
  }, [_vm._v("Mappings")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.mappings), function(item, index) {
    return _c('v-list-group', {
      key: item.ResponsePath,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "avatar": "",
        "ripple": ""
      },
      slot: "item"
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.ResponsePath))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.Description))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v("\n                                    " + _vm._s(item.PropertyId) + "\n                                ")])], 1)], 1)], 1)
  }))], 1)], 1)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 395:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "grey lighten-5"
  }, [_c('v-tabs-slider', {
    staticClass: "amber"
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab,
      attrs: {
        "ripple": "",
        "href": '#' + tab
      }
    }, [_vm._v("\n                " + _vm._s(tab) + "\n            ")])
  })], 2)], 1), _vm._v(" "), (_vm.consents.length === 0) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-2 grey--text text--darken-1"
  }, [_vm._v("No results")]) : [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.consents && _vm.consents.length > 0) ? _c('v-card', [_c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, _vm._l((_vm.consents), function(item, index) {
    return _c('v-list-tile', {
      key: _vm.key(item),
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.details(item, index)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: item.Status
    }, [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.DataOwnerCode))]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(item.Intent.ShortDescription))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.userReadable(item.Expiration)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "visible-hover"
    }, [_vm._v("mode_edit")])], 1)], 1)
  }))], 1) : _vm._e()], 1)], 1)]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "purple--text",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Login callback ...")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-progress-circular', {
    staticClass: "purple--text",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Login ...")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.properties.length === 0) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-2 grey--text text--darken-1"
  }, [_vm._v("\n        No results\n    ")]) : [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "one-line": ""
    }
  }, _vm._l((_vm.properties), function(item, index) {
    return _c('v-list-group', {
      key: item.Code,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.details(item.Code)
        }
      },
      slot: "item"
    }, [(item.Icon) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(item.Icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.Name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(item.Code))])], 1)], 1)], 1)
  }))], 1)], 1)], 1)]], 2)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.d78e2aa68246de9cb893.js